import { useSelector } from "react-redux";
import { authSelector } from "../../store";

type HasPermissionFn = (requiredPermissions?: string[]) => boolean;

interface UsePermissionInterface {
  hasPermission: HasPermissionFn;
}
export const usePermission = (): UsePermissionInterface => {
  const {
    data: { privileges },
  } = useSelector(authSelector);
  const hasPermission: HasPermissionFn = (requiredPermissions) => {
    if (requiredPermissions) {
      for (const requiredPermission of requiredPermissions) {
        if (privileges?.includes(requiredPermission)) {
          return true;
        }
      }
      return false;
    }
    // default if no permission Required
    return true;
  };
  return {
    hasPermission,
  };
};
